import { Box, Stack, StackDivider, Text, TextProps } from "@chakra-ui/react";

export function createPopupContainerChildren(
  items: {
    label: string;
    labelProps?: TextProps;
    value: string;
  }[],
) {
  return (
    <Stack spacing="1" divider={<StackDivider />}>
      {items.map(
        ({
          label,
          labelProps,
          value,
        }: {
          label: string;
          labelProps?: TextProps;
          value: string;
        }) => (
          <Box key={label}>
            <Text fontSize="xs" {...labelProps}>
              {value}
            </Text>
            <Text fontSize="10px" color="subtle">
              {label}
            </Text>
          </Box>
        ),
      )}
    </Stack>
  );
}
